import { render, staticRenderFns } from "./WorldHeader.vue?vue&type=template&id=bf2ad2ae&scoped=true&"
import script from "./WorldHeader.vue?vue&type=script&lang=js&"
export * from "./WorldHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorldHeader.vue?vue&type=style&index=0&id=bf2ad2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2ad2ae",
  null
  
)

export default component.exports